import "./Footer.css"

export const Footer=()=>{



    return (

        <footer>
             <p className="footer_p">© 2024 KOSTA</p>
             <a href="https://hijuu.tistory.com/13" className="footer_p footer_a" >상세설명</a>
        </footer>
    )
}